import React from 'react';

import { Tooltip, TooltipContent, TooltipTrigger } from '../../ui/tooltip';
import type { Citation, ConversationCallbacks } from '../types';
import { Button } from '../../ui/button';

interface CitationBlockProps {
  citations: Citation[];
  onCitationClick?: ConversationCallbacks['onCitationClick'];
}

export const CitationBlock = ({ citations, onCitationClick }: CitationBlockProps) => {
  return (
    <span className="inline-flex flex-wrap gap-1">
      {citations.map((citation) => (
        <CitationBadge key={citation.id} citation={citation} onClick={onCitationClick} />
      ))}
    </span>
  );
};

interface CitationBadgeProps {
  citation: Citation;
  onClick?: ConversationCallbacks['onCitationClick'];
}

const CitationBadge = ({ citation, onClick }: CitationBadgeProps) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          size="xs"
          variant="ghost"
          className="size-5 text-xs text-muted-foreground"
          onClick={() => onClick?.(citation)}
        >
          {citation.index}
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-xs">
        <p className="text-sm font-medium">{citation.title}</p>
        <p className="text-xs truncate">{citation.url}</p>
      </TooltipContent>
    </Tooltip>
  );
};
